/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";
import { Button } from 'reactstrap';
import { db } from '../firebase';
import { onAuthStateChanged } from "firebase/auth"; // Importuj funkcję
import { doc, getDoc, setDoc } from "firebase/firestore"; // Importuj niezbędne funkcje z Firestore
import { auth } from "../firebase"
import { useNavigate } from "react-router-dom";

function Holidays() {
  const [holidays, setHolidays] = useState();
  const navigate = useNavigate();

  const holidaysFromDB = async () => {
    try {
      // Referencja do dokumentu w kolekcji
      const docRef = doc(db, 'calendar', 'i5UKDRTsOKiBbTcUWiN6');
      const response = await getDoc(docRef); // Pobieranie dokumentu
  
      const holidayArray = [];
      if (response.exists() && response.data().holidays) { // Sprawdzanie istnienia dokumentu
        response.data().holidays.forEach((holiday) => {
          const holidayDate = new Date(holiday.seconds * 1000 + holiday.nanoseconds / 1000000);
          holidayArray.push(holidayDate.toISOString().split('T')[0]); // Formatowanie daty do YYYY-MM-DD
        });
      }
  
      setHolidays(holidayArray); // Ustawienie stanu z tablicą dni wolnych
    } catch (error) {
      console.error("Error fetching holidays:", error); // Obsługa błędów
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) { // Sprawdzenie, czy użytkownik jest zalogowany
        if (user.displayName === 'porter') {
          navigate('/super-admin/parking-map');
        } else if (user.displayName === 'manager') {
          navigate('/super-admin/pre-alerts-managment');
        }
      }
    });

    // Zwrócenie funkcji unsubscribing do czyszczenia
    return () => unsubscribe();
  }, [navigate]); // Dodanie navigate do zależności

  useEffect(() => {
    holidaysFromDB();
  }, [])

  const handleUpdate = async () => {
    try {
      // Konwertuj ciąg z datami na tablicę
      const holidayArray = holidays.split(',').map(date => new Date(date.trim()));
  
      // Referencja do dokumentu 'calendar'
      const docRef = doc(db, 'calendar', 'i5UKDRTsOKiBbTcUWiN6');
      // Aktualizacja dokumentu w Firestore
      await setDoc(docRef, {
        holidays: holidayArray
      });
  
      // Przeładuj stronę po zakończeniu aktualizacji
      window.location.reload();
  
    } catch (err) {
      console.error("Error updating holidays:", err); // Obsługa błędów
    }
  };

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <div className="content" style={{ display: 'flex', flexDirection: 'column' }}>
        <h5>Please enter vacation dates in the following format: 2024-12-28,2024-12-29.</h5>
        <textarea value={holidays} onChange={(e) => setHolidays(e.target.value)} style={{ width: '60%', height: '100px', padding: '10px', border: '1px solid #a6a6a6', borderRadius: '8px' }}></textarea>
        <Button onClick={handleUpdate} className="btn btn-warning" style={{ width: '100px' }}>Update</Button>
      </div>
    </>
  );
}

export default Holidays;
